import React from 'react';
import { Checkbox } from './ui/checkbox';

export const CONSENT_TEXT = 'Yes, send me emails from The WE Mentality about leadership development, DISC assessments, team training, workshops, and strategic planning services. You can unsubscribe at any time.';

export const MarketingConsentCheckbox = ({ checked, onChange, note, testId = 'marketing-consent' }) => (
  <div className="flex items-start gap-3 pt-1">
    <Checkbox id={testId} checked={!!checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5 border-slate-500" data-testid={testId} />
    <label htmlFor={testId} className="text-xs sm:text-sm text-slate-400 cursor-pointer leading-relaxed">
      <span className="font-medium text-slate-300">Optional:</span> {CONSENT_TEXT} {note}
    </label>
  </div>
);
